<template>
  <div class="notice">
    <div class="panel panel-default">
      <div class="panel-heading">
        <h4 class="panel-title"><span class="notice-img"><img :src="notice.src" alt=""></span>&nbsp;{{notice.title}}
          <template v-if=" num===2 ">
            <a href="purchase.html?num=2" class="pull-right a-more">更多&gt;</a>
          </template>
          <template v-else>
            <a href="javascript:;" class="pull-right a-more hidden">更多&gt;</a>
          </template>
        </h4>
      </div>
      <div class="panel-body min-height">
        <template v-if="notice.content">
          <div v-for="info in notice.content">
            <a href="javascript:;" :title="info.messageContent||info.title" class="list-group-item list-padding"
               @click="detailed(info.link,info.msgId,info.id)"><span
              class="list-dot">·</span>&nbsp;{{info.messageContent||info.title}}</a>
          </div>
        </template>
        <template v-else>
          <p class="notcie-error-handling">暂无数据</p>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .list-group-item {
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    overflow: hidden;
  }

  .notice-img {
    position: relative;
    top: -1px;
  }

  .a-more {
    font-size: 13px;
    color: #666666 !important;
    position: relative;
    top: 1px;
  }

  .a-more:hover {
    text-decoration: none;
    padding-bottom: 5px;
    border-bottom: 1px solid red;
    color: #e22e1c !important;
  }

  .notice .panel {
    border-radius: 0px;
  }

  .min-height {
    min-height: 247px;
  }

  .min-height > div {
    cursor: pointer;
  }

  .notcie-error-handling {
    text-align: center;
    margin-top: 80px;
  }
</style>

<script>
  import {apiLinks} from '../api/links.js'
  export default {
    name: 'notice',
    props: {
      // 基础类型检测 （`null` 意思是任何类型都可以）
      type: '',
      apiUrl: '',
      num: '',
      ajaxType:''
    },
    data () {
      return {
        notice: '',
        companyNotices: {
          src: 'static/imgs/qygg.png',
          title: '企业公告',
          content: ''
        },
        biddingNotices: {
          src: 'static/imgs/zbgg.png',
          title: '中标公告',
          content: ''
        },
        clarifyNotices: {
          src: 'static/imgs/cqgg.png',
          title: '澄清公告',
          content: ''
        },
        links: {
          src: 'static/imgs/yqlj.png',
          title: '友情链接',
          content: [
            {
              messageContent: '南方水泥官方网站',
              link: 'http://www.scement.cn/cn/'
            },
            {
              messageContent: '中国建筑材料集团有限公司',
              link: 'http://www.cnbm.com.cn/'
            },
            {
              messageContent: '中国建材股份有限公司',
              link: 'http://www.cnbm.com.cn/'
            },
            {
              messageContent: '南方水泥有限公司成员企业',
              link: 'http://www.scement.cn/cn/About.aspx?Class_ID=21'
            },
            {
              messageContent: '西域网',
              link: 'http://www.ehsy.com'
            }
          ]
        }
      }
    },
    mounted: function () {
      this.staticData(this.type)
      if (this.apiUrl !== '') {
        this.getDate()
      }
    },
    methods: {
      getDate: function () {
        this.$http.jsonp(this.apiUrl, []).then(function (response) {
          if(response.data[0].data){
            this.notice.content = response.data[0].data.results
          }else{
            this.notice.content = response.data[0]['result']
          }
        }, function (response) {
        })
      },
      staticData: function (type) {
        switch (type) {
          case 'company':
            this.notice = this.companyNotices
            break
          case 'bidding':
            this.notice = this.biddingNotices
            break
          case 'clarify':
            this.notice = this.clarifyNotices
            break
          case 'links':
            this.notice = this.links
            break
          default:
            console.log('没有进switch')
            break
        }
      },
      detailed: function (href, msgid, id) {
        if (href) {
          window.location.href = href
        } else {
          if (this.type === 'company') {
            window.open(apiLinks.details['company'] + id)
          } else {
            window.open(apiLinks.details['bidNotice'] + msgid)
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// notice.vue?95a08d8c